import feathers from './feathers';

var auth = {
   fetchUser: async token => {
      return new Promise(async (resolve, reject) => {
         try {
            let payload = await feathers.passport.verifyJWT(token);

            let user = await feathers.service('users').get(payload.userId);
            feathers.set('user', user);

            if (typeof window.require !== 'undefined') {
               global.electron.localStorage.setItem('user', user);
               global.electron.feathers.io.emit('register-station', {
                  ...user,
                  isStation: true
               });
            }

            resolve(user);
         } catch (err) {
            console.log('process.env.NODE_ENV', process.env.NODE_ENV);
            if (process.env.NODE_ENV === 'development') {
               auth.logout();
               console.log('errorAuth', err);
            }
            reject(err);
         }
      });
   },
   authenticate: async () => {
      let token = await feathers.passport.getJWT();

      let authenticated = await feathers.authenticate({
         strategy: 'jwt',
         accessToken: token
      });

      let user = await auth.fetchUser(authenticated.accessToken);

      return user;
   },
   login: async (email, password) => {
      let authenticated = await feathers.authenticate({
         strategy: 'local',
         email: email,
         password: password
      });

      let user = await auth.fetchUser(authenticated.accessToken);

      return user;
   },
   logout: async () => {
      let logout = await feathers.logout();
      if (typeof window.require !== 'undefined') {
         global.electron.localStorage.removeItem('user');
         global.electron.localStorage.removeItem('user_id');

         global.electron.feathers.io.emit(
            'unregister-station',
            global.electron.feathers.get('user')
         );
      }
      console.log('Logout', logout);
      // window.location.href = '/';
   }
};

export default auth;
